module.exports = __webpack_public_path__ + "static/media/I_goodnest_ui.0670f32e.png";